import { Info, ShieldCheck } from "lucide-react";

export const BrandDisambiguation = () => {
  return (
    <div className="glass-card p-4 rounded-lg border border-border/50 bg-muted/20 text-center space-y-3">
      <div>
        <div className="flex items-center justify-center gap-2 mb-2">
          <Info className="h-4 w-4 text-muted-foreground" />
          <p className="text-sm font-semibold text-foreground">
            About Spotivibly
          </p>
        </div>
        <p className="text-xs text-muted-foreground leading-relaxed">
          <strong className="text-foreground">Spotivibly</strong> is an independent AI-powered playlist generator
          that creates playlists for <strong>Spotify</strong> and <strong>YouTube</strong>.
          We are <strong>not affiliated with, endorsed by, or connected to</strong> Spotify AB,
          Spotify Technology S.A., or Google LLC. We use their public APIs to provide
          a playlist generation service.
        </p>
      </div>
      <div className="pt-2 border-t border-border/40">
        <div className="flex items-center justify-center gap-2 mb-1">
          <ShieldCheck className="h-4 w-4 text-muted-foreground" />
          <p className="text-xs font-semibold text-foreground">
            Your accounts stay safe
          </p>
        </div>
        <p className="text-xs text-muted-foreground leading-relaxed">
          We <strong>never ask for your Spotify password</strong>. Playlists are built on our public
          curator account and shared with you via an official Spotify link. No credential harvesting,
          no "free Premium" offers, no human-verification surveys. Just a playlist generator.
        </p>
      </div>
    </div>
  );
};

